import { BsCartPlusFill } from 'react-icons/bs';

function EmptySection() {
    return (
        <tr className=" flex h-full w-full flex-col items-center justify-center bg-white py-10">
            <BsCartPlusFill size={42} />
            <h1 className=" text-[30px] font-semibold">Your Cart is Empty</h1>
            <p>Please add some items to your cart</p>
        </tr>
    );
}

export default EmptySection;
